<app-pat-payment-panel-stripe-generic
  type="STRIPE_GOOGLE_PAY"
  [isPayButtonVisible]="false"
></app-pat-payment-panel-stripe-generic>
